import { useTheme } from '@mui/material';

export const useBannerColours = (variant = 'info') => {
	const theme = useTheme();
	const isDarkMode = theme.palette.mode === 'dark';

	if (variant === 'error') {
		return {
			backgroundColor: isDarkMode ? theme.palette.darkModeSideNav : '#FDEDED',
			border: isDarkMode ? `1px solid ${theme.palette.error.main}` : '1px solid #F5A9A9',
			textColor: isDarkMode ? theme.palette.folioWhite : '#611A15',
		};
	}

	return {
		backgroundColor: isDarkMode ? theme.palette.darkModeSideNav : theme.palette.dialogActions,
		border: `1.5px solid ${theme.palette.primary.main}`,
		textColor: isDarkMode ? theme.palette.folioWhite : theme.palette.folioBlack100,
		secondaryTextColor: isDarkMode ? theme.palette.folioWhite65 : theme.palette.folioRegular,
	};
};
